<script setup lang="ts">
import { computed } from 'vue'

import { useEditorStore } from '@/stores/Editor'
import { usePublicData } from '@/stores/PublicData'

import BaseList from '@/components/common/BaseList.vue'

const editorStore = useEditorStore()
const publicStore = usePublicData()

const achievements = computed(
  () => editorStore.editor.goalsAchievements[publicStore.lang].achievements,
)
</script>

<template>
  <div class="mb-5">
    <BaseList v-model="achievements" />
  </div>
</template>

<style lang="scss" scoped></style>
